<template>
  <div class="signup__step signup__step--03 online-selling">
    <div class="stepForm">
      <div class="content online-selling">
        <div class="content__header">
          <h2 class="content__title">Informações do seu negócio</h2>
          <p class="content__description">
            Pode nos contar um pouco mais sobre o seu negócio? Suas respostas
            nos ajudam a <br/>
            personalizar sua experiência no Melhor Envio!
          </p>
        </div>

        <div class="online-selling__questions-container">
          <h3
            class="online-selling__question-title space-sessions-top space-sessions-bottom"
            :class="alertErrorTitleClass(sellsOnlineError)"
          >
            Você já vende online?*
          </h3>
          <div class="card-container card-container--center-align">
            <div v-for="item in sellsOnlineOptions" :key="item.value">
              <label>
                <div
                  class="card card--small"
                  :class="{ 'card--selected': sellsOnline == item.value }"
                  :data-cy="`online-button-${item.value}`"
                >
                  <div class="card__inner-container">
                    <p class="card-text card-text--center">
                      {{ item.text }}
                    </p>
                    <img
                      class="card-icon card-icon--top-right"
                      src="/images/registration/success-blue.svg"
                      alt="Sucesso"
                      v-if="sellsOnline == item.value"
                    />
                  </div>
                </div>
                <input
                  type="radio"
                  :value="item.value"
                  v-model="sellsOnline"
                />
              </label>
            </div>
          </div>
        </div>

        <div v-if="sellsOnline === 'yes'" class="online-selling__questions-container">
          <h3
            class="online-selling__question-title space-sessions-top space-sessions-bottom"
            :class="alertErrorTitleClass(sellMoreError)"
          >
            Onde você mais vende?*
          </h3>
          <div class="card-container">
            <div v-for="item in sellMore" :key="item.id">
              <label>
                <div
                  class="card"
                  :class="{ 'card--selected': selectedSellMore == item.text }"
                  :data-cy="`online-button-${item.id}`"
                >
                  <p class="card-text">
                    {{ item.text }}
                  </p>

                  <img
                    class="card-icon"
                    src="/images/registration/success-blue.svg"
                    alt="Sucesso"
                    v-if="selectedSellMore == item.text"
                  />

                  <me-tooltip v-else-if="item.tooltip" :message="item.tooltip">
                    <img
                      class="card-icon"
                      src="/images/registration/info-grey.svg"
                      alt="Info"
                    />
                  </me-tooltip>
                </div>

                <input
                  type="radio"
                  :value="item.text"
                  v-model="selectedSellMore"
                />
              </label>
            </div>
          </div>

          <div class="space-sessions-top space-sessions-bottom">
            <h3
              :class="alertErrorTitleClass(salesPerMonthError)"
              class="online-selling__question-title"
            >
              Qual sua estimativa mensal de envios <span class="break-point"> com o Melhor Envio?* </span>
            </h3>
            <span
              :class="alertErrorTitleClass(salesPerMonthError)"
              class="online-selling__question-description"
            >
              Sua resposta nos ajuda a saber mais sobre o seu negócio e não interfere no seu limite de envios.
            </span>
          </div>
          <div class="card-container">
            <div v-for="item in salesPerMonth" :key="item.id">
              <label>
                <div
                  class="card"
                  :class="{ 'card--selected': selectSalesPerMonth == item }"
                  :data-cy="`online-button-${item.id}`"
                >
                  <p class="card-text">{{ item.value }}</p>

                  <img
                    class="card-icon"
                    src="/images/registration/success-blue.svg"
                    alt="Sucesso"
                    v-if="selectSalesPerMonth == item.value"
                  />
                </div>

                <input type="radio" :value="item.value" v-model="selectSalesPerMonth"/>
              </label>
            </div>
          </div>
        </div>

        <div v-if="sellsOnline === 'no'" class="online-selling__questions-container space-sessions-top">
          <h3
            class="online-selling__question-title space-sessions-bottom"
            :class="alertErrorTitleClass(sellsNotToSellOnlineError)"
          >
            Em qual opção você se encaixa melhor?*
          </h3>

          <div class="card-container">
            <div v-for="item in reasonsNotToSellOnline" :key="item.id">
              <label>
                <div
                  class="card"
                  :class="{ 'card--selected': selectNotToSellOnline == item.text }"
                  :data-cy="`online-button-${item.id}`"
                >
                  <p class="card-text"> {{ item.text }}</p>

                  <img
                    class="card-icon"
                    src="/images/registration/success-blue.svg"
                    alt="Sucesso"
                    v-if="selectNotToSellOnline == item.text"
                  />

                  <me-tooltip v-else-if="item.tooltip" :message="item.tooltip">
                    <img
                      class="card-icon"
                      src="/images/registration/info-grey.svg"
                      alt="Info"
                    />
                  </me-tooltip>
                </div>

                <input
                  type="radio"
                  :value="item.text"
                  v-model="selectNotToSellOnline"
                />
              </label>
            </div>
          </div>
        </div>

        <div v-if="hasError" class="error-message">
          <p class="error-message__content">
            <img
              class="error-message__icon"
              src="/images/registration/error-red.svg"
              alt="!"
            />
            {{ errorMessage }}
          </p>
        </div>

        <div class="button__container">
          <button
            v-if="sellsOnline === 'no'"
            name="Pular formulário"
            type="submit"
            class="button button--outline"
            @click="skipForm"
            data-cy="online-button-skip-form"
          >
            pular
          </button>

          <button
            name="Avançar formulário"
            type="submit"
            class="button button--primary button__left-space"
            @click="submit"
            data-cy="online-button-confirm"
          >
            avançar
          </button>
        </div>
      </div>
    </div>

    <!-- error modal -->
    <transition name="fade">
      <modal-base
        v-if="$parent.showModal"
        title='Atenção!'
        class="lead-form__error-modal"
      >
        <template v-slot:close-icon>
          <svg @click.prevent='$parent.showModal = false' class='modal__close-icon'>
            <use xlink:href='/images/svg-symbols.svg#close' />
          </svg>
        </template>
        <template v-slot:content>
          <p style="text-align: center !important">
            Ops! Ocorreu um erro no seu cadastro. <br>
            {{
              modalErrorMessage
                ? "modalErrorMessage"
                : "Por favor, verifique suas informações."
            }}
          </p>
        </template>
        <template v-slot:footer>
          <button class="button button--primary" @click.prevent="$parent.showModal = false">
            Tentar novamente
          </button>
        </template>
      </modal-base>
    </transition>
  </div>
</template>

<script>
import Tooltip from "commons/js/components/atoms/Tooltip.vue";
import ModalBase from "commons/js/components/atoms/ModalBase.vue";
import { nanoid } from 'nanoid'

import {scrollToTop} from 'commons/js/utils/scroll.js';

export default {
  components: {
    "me-tooltip": Tooltip,
    ModalBase
  },
  data() {
    return {
      sellsOnline: null,
      sellsOnlineOptions: [
        {
          text: "Sim",
          value: "yes"
        },
        {
          text: "Não",
          value: "no"
        }
      ],
      sellMore: [],
      salesPerMonth: [],
      reasonsNotToSellOnline: [],
      selectedSellMore: null,
      selectSalesPerMonth: null,
      selectNotToSellOnline: null,
      hasError: false,
      sellMoreError: null,
      salesPerMonthError: null,
      sellsOnlineError: null,
      sellsNotToSellOnlineError: null,
      skippingOptionNotToSellOnline: false,
      errorMessage: 'Campos obrigatórios! Não esqueça de selecionar suas respostas.',
      modalErrorMessage: ''
    };
  },
  created(){
    this.getOnlineSellingOptions();
  },
  mounted(){
    scrollToTop();
  },
  watch: {
    sellsOnline(newValue) {
       if (newValue !== null) {
        this.selectedSellMore = this.selectSalesPerMonth = this.selectNotToSellOnline = null;
        this.hasError = false;
        this.sellsOnlineError = false;
        this.sellMoreError = this.salesPerMonthError = this.sellsNotToSellOnlineError = null;
      }
    },
    selectedSellMore(newValue) {
      if (newValue) {
        this.sellMoreError = null;
      }
      this.clearErrorMessage();
    },
    selectSalesPerMonth(newValue) {
      if (newValue) {
        this.salesPerMonthError = null;
      }
      this.clearErrorMessage();
    },
    selectNotToSellOnline(newValue) {
      if (newValue) {
        this.sellsNotToSellOnlineError = null;
      }
      this.hasError = false;
    }
  },
  methods: {
    clearErrorMessage() {
      if (this.hasAnyError()) {
        this.hasError = false;
      }
    },
    hasAnyError() {
      return !!(this.sellsOnline && this.selectSalesPerMonth && this.selectedSellMore);
    },
    alertErrorTitleClass(showAlert) {
      return showAlert ? 'online-selling__question-title--error' : '';
    },
    isValid() {
      if (this.sellsOnline === null) {
        return false;
      }

      if (this.sellsOnline === 'yes' && (!this.selectedSellMore || !this.selectSalesPerMonth)) {
        return false;
      }

      if (!this.skippingOptionNotToSellOnline && (this.sellsOnline === 'no' && !this.selectNotToSellOnline)) {
        return false;
      }

      return true;
    },
    getOnlineSellingOptions() {
      axios.get("/api/v2/me/settings/online-selling-options")
      .then((response) => {
        Object.values(response.data.sellMoreOptions).forEach((sellMoreOption) => {
          this.sellMore.push({
            text: sellMoreOption.title,
            tooltip: sellMoreOption.description,
            id: sellMoreOption.id
          });
        });

        Object.values(response.data.shipmentsAverageOptions).forEach((shipmentsAverageOption) => {
          this.salesPerMonth.push(shipmentsAverageOption);
        });

        Object.values(response.data.reasonsNotToSellOnline).forEach((reasonNotToSellOnline) => {
          this.reasonsNotToSellOnline.push({
            text: reasonNotToSellOnline.title,
            tooltip: reasonNotToSellOnline.description,
            id: reasonNotToSellOnline.id
          });
        });
      })
      .catch(() => {
        this.setErrorModalMessage(error.response.status);
        $this.$parent.showModal = true;
      });
    },
    skipForm() {
      this.skippingOptionNotToSellOnline = true;
      this.submit();
    },
    submit() {
      let answers = {
        shipments_average: this.selectSalesPerMonth,
        where_do_you_sell: this.selectedSellMore,
        why_do_you_not_sell: this.selectNotToSellOnline
      }

      this.hasError = !this.isValid();

      if (this.hasError) {
        this.sellsOnlineError = !this.sellsOnline;
        this.sellMoreError = !this.selectedSellMore;
        this.salesPerMonthError = !this.selectSalesPerMonth;
        this.sellsNotToSellOnlineError = !this.selectNotToSellOnline;
        return;
      }

      this.$parent.loading = true;

      Object.keys(answers).forEach((key) => {
        if (!answers[key]) delete answers[key];
      });

      axios.put("/api/v2/me/settings/quiz", answers).then((response) => {
        if (response.status === 204) {
          this.$parent.next();
          scrollToTop();
        }
      }).catch(() => {
        this.setErrorModalMessage(error.response.status);
        this.$parent.showModal = true;
      }).finally(() => {
        this.$parent.loading = false;
      });
    },
    setErrorModalMessage(errorStatus) {
      switch (errorStatus) {
        case 401:
          this.modalErrorMessage = 'Parece que você não está logado no sistema.';
          break;

        case 422:
          this.modalErrorMessage = 'Existem erros no preenchimento dos campos.';
          break;

        default:
          break;
      }
    },

    /**
     * Generates a unique id to be used
     * as a key for the items in the options array
     * @returns {String} - ID
     */
    generateUniqueID() {
      return nanoid();
    }
  }
};
</script>

<style lang="stylus" scoped>
$theme-danger = #E7505A

.online-selling
  font-family 'Lato', 'Open Sans', sans-serif
  text-align center

  &__question-description
    color #697882
    line-height 18px

  &__question-title
    font-size 16px
    font-weight bold
    color #697882
    text-align center

    &--error
      color $theme-danger

  .space-sessions
    &-top
      margin-top 32px

    &-bottom
      margin-bottom 24px

  .card
    width calc(70vw - 16px)
    margin 8px auto
    padding 12px 16px
    background-color #fff
    box-shadow 0px 2px 5px #26303C33
    border-radius 4px
    border 1px solid #fff
    color #697882

    // card content
    display flex
    justify-content space-between
    align-items center

    &:hover
      border-color #0A539B
    @media screen and (min-width 500px)
      width calc(60vw - 16px)

    @media screen and (min-width 500px)
      width 312px
      margin 8px

    &-text
      font-size 10px

      @media screen and (min-width 500px)
        font-size 14px

      &--center
        width 100%
        height 100%
        display flex
        flex-flow row nowrap
        align-content center
        align-items center
        justify-content center

    &-icon
      width 16px
      height 16px

      &--top-right
        position absolute
        right -8px
        top -4px

      @media screen and (max-width 320px)
        width 12px
        height 12px

    &--small
      width 176px
      height 64px
      justify-content center

    &--selected
      border-color #0A539B

    &__inner-container
      width 100%
      height 100%
      position relative

    &-container
      max-width 100%
      display flex
      flex-flow row wrap
      align-items center
      justify-content center

      @media screen and (min-width 756px)
        max-width 724px
        margin 0 auto
        justify-content flex-start

      // hide radio input
      input
        display none !important

      label
        cursor pointer

      &--center-align
        align-items center
        justify-content center

.error-message
  max-width 100%
  margin 28px auto 0 auto
  border-radius 4px
  border 1px solid $theme-danger

  @media screen and (min-width 500px)
    max-width 704px

  &__content
    color $theme-danger
    text-align left
    padding 12px 16px
    display flex
    align-items center

  &__icon
    width 16px
    height 16px
    margin-right 12px

span.break-point {
  display: inline-block;
}
</style>
